module.exports = new __parcel__URL__("icecream-accident.69b5c609.svg").toString();